import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type SystemIdsResponse = {
  systemIds: string[]
}

const SYSTEM_IDS_BY_PROGRAM_KEY = 'system-ids-by-program'

export const useGetSystemIds = (programId?: string) => {
  return useQuery({
    queryKey: [SYSTEM_IDS_BY_PROGRAM_KEY, programId],
    queryFn: async () => {
      const { data } = await apiClient.get<SystemIdsResponse>(`/int/v3/programs/${programId}/system-ids`)

      return data.systemIds.filter((id) => id !== null && id !== undefined)
    },
    enabled: Boolean(programId),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  })
}
